import { get_session } from '../../apis/user_api'

export const initUserInfoBySession = ({ dispatch }) => {
  return get_session().then(res => {
    if (res.ok && res.data.errcode == 0)
      dispatch('SET_USER_INFO', res.data.data);
    return res;
  })
};

export const setUserInfo = ({ dispatch }, userInfo) => {
  dispatch('SET_USER_INFO', userInfo)
};



// WEBPACK FOOTER //
// ./src/vuex/actions/user_actions.js